// extracted by mini-css-extract-plugin
module.exports = {"large":"only screen and (min-width: 992px)","emptyFeed":"_3Y7No","relatedProductsArea":"_2-Y3_ _3rXvv _2dO1W _3gDJ4 _3krpm _1PQHc"};